import Recat, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Select, message, Spin, Upload } from 'antd'
import { SGeneralForms, SFormUploadImage } from 'shj-components'
import { baseURL } from '@/api'
import { isNil } from 'lodash-es';
export const AddOrEditForm = Recat.forwardRef((props: any, ref) => {
    const { disabled, authVisible, companyList = [], data = {}, taxPayerTypeList = [] } = props;
    const formRef: any = useRef()
    const [spinning, setSpinning] = useState(false)
    const reqMeg = '不能为空'
    useImperativeHandle(ref, () => ({
        getValue: () => formRef.current?.onFormRef()?.getFieldsValue(),
        validateFields: () => formRef.current?.onFormRef()?.validateFields(),
    }));
    useEffect(() => {
        if (data) {
            let values = {
                ...data,
            };
            const fileFields = ['financialSealFile', 'identityFile', 'sealFile', 'siagnApplication'];

            fileFields.forEach(field => {
                if (data[field]) {
                    values[field] = data[field].split(',').map((d: any, i: number) => getFileItem(d, i));
                }
            });
            formRef.current?.onFormRef()?.setFieldsValue(values);
        }
        return () => { };
    }, [data]);
    const getFileItem = (item: any, i: number) => ({
        uid: i,
        name: item[i].fileName ? item[i].fileName : i,
        status: 'done',
        url: item,
        fullUrl: item,
    });
    const beforeUpload = (file: any) => {
        if ((file.type || '').startsWith('image')) {
          if (
            !file.name.endsWith('.jpg') &&
            !file.name.endsWith('.png') &&
            !file.name.endsWith('.jpeg')
          ) {
            message.error('图片必须是jpg/jpeg/png格式')
            return Upload.LIST_IGNORE
          }
          return true
        }
        message.error('只能上传图片')
        return Upload.LIST_IGNORE
    }
    const getOptions = async () => {
        return Promise.resolve({
            companyList,
            taxPayerTypeList,
        })
    }
    return (
        <Spin spinning={spinning}>
            <SGeneralForms
                ref={formRef}
                layout="vertical"
                httpOptionsFn={getOptions}
                configs={[
                    {
                        formItem: [
                            { label: 'id', name: 'id', hidden: true },
                            {
                                label: '财务主体编码',
                                name: 'financialOrgCode',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }, {
                                    pattern: /^[a-zA-Z0-9]{3}$/,
                                    message: '编码必须为3位',
                                },],
                                comConfig: {
                                    maxLength: 3,
                                    disabled: disabled || authVisible
                                },
                            },
                            {
                                label: '财务主体名称', name: 'companyFullName', spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                 comConfig: {
                                    maxLength: 30,
                                    disabled: disabled || authVisible
                                }
                            },
                            {
                                label: '公司名称',
                                name: 'companyIds',
                                spanCol: 12,
                                type: 'select',
                                data: 'companyList',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    fieldNames: { value: 'orgId', label: 'companyName' },
                                    disabled: disabled,
                                    mode: 'multiple'
                                },
                            },
                            {
                                label: '纳税人识别号',
                                name: 'companyIdentityNum',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 20,
                                    disabled: disabled || authVisible
                                },
                            },
                            {
                                label: '法人名称',
                                name: 'identityName',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                spanCol: 12,
                                comConfig: {
                                    maxLength: 30,
                                    disabled: disabled || authVisible
                                },
                            },
                            {
                                label: '法人证件号码',
                                name: 'identityCardCode',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 30,
                                    disabled: disabled || authVisible
                                },
                            },
                            {
                                label: '纳税人类型',
                                name: 'taxPayerType',
                                spanCol: 12,
                                type: 'select',
                                data: 'taxPayerTypeList',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    fieldNames: { value: 'key', label: 'description' },
                                    disabled: disabled
                                },
                            },
                            {
                                label: '是否自动签名',
                                name: 'autoSign',
                                type: 'switch',
                                spanCol: 12,
                                comConfig: {
                                    checkedChildren: '是',
                                    unCheckedChildren: '否',
                                    disabled: disabled
                                },
                            },
                            {
                                label: '公司邮箱',
                                name: 'email',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 20,
                                    disabled: disabled
                                },
                            },
                            {
                                label: '联系电话',
                                name: 'mobile',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 20,
                                    disabled: disabled
                                },
                            },
                            {
                                label: '公司地址',
                                name: 'companyAddress',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 50,
                                    disabled: disabled
                                },
                            },
                            {
                                label: '开户行帐号',
                                name: 'bankAccount',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 30,
                                    disabled: disabled
                                },
                            },
                            {
                                label: '开户行名称',
                                name: 'bankName',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 30,
                                    disabled: disabled
                                },
                            },
                            {
                                label: '开票收件人电话',
                                name: 'billRecipientPhone',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 20,
                                    disabled: disabled
                                },
                            },
                            {
                                label: '开票收件人名称',
                                name: 'billRecipientName',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 30,
                                    disabled: disabled
                                },
                            },
                            {
                                label: '开票收件地址',
                                name: 'billRecipientAddr',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 30,
                                    disabled: disabled
                                },
                            },
                            {
                                label: '营业执照',
                                name: 'identityFile',
                                spanCol: 12,
                                required: true,
                                // isHideItem: !isNil(data.id) && isNil(data.siagnApplication),
                                rules: [{ required: true, message: reqMeg }],
                                extra: '规格：150像素（宽）*150像素（高），白底透明，支持JPG、JPEG、PNG格式',
                                children: (
                                    <SFormUploadImage
                                        accept={'.jpg,.jpeg,.png'}
                                        beforeUpload={beforeUpload}
                                        disabled={disabled || authVisible}
                                        maxCount={1}
                                        limit={1}
                                        url={baseURL + '/file-web/file/upload'}
                                    />
                                ),
                            },
                            {
                                label: '印章',
                                name: 'sealFile',
                                spanCol: 12,
                                // isHideItem: !isNil(data.id) && isNil(data.sealFile),
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                extra: '规格：150像素（宽）*150像素（高），白底透明，支持JPG、JPEG、PNG格式',
                                children: (
                                    <SFormUploadImage
                                        accept={'.jpg,.jpeg,.png'}
                                        beforeUpload={beforeUpload}
                                        disabled={disabled || authVisible}
                                        maxCount={1}
                                        limit={1}
                                        url={baseURL + '/file-web/file/upload'}
                                    />
                                ),
                            },
                            {
                                label: '授权书',
                                name: 'siagnApplication',
                                spanCol: 12,
                                // isHideItem: !isNil(data.id) && isNil(data.siagnApplication),
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                extra: '规格：150像素（宽）*150像素（高），白底透明，支持JPG、JPEG、PNG格式',
                                children: (
                                    <SFormUploadImage
                                        accept={'.jpg,.jpeg,.png'}
                                        beforeUpload={beforeUpload}
                                        disabled={disabled || authVisible}
                                        maxCount={1}
                                        limit={1}
                                        url={baseURL + '/file-web/file/upload'}
                                    />
                                ),
                            },
                            {
                                label: '财务印章',
                                name: 'financialSealFile',
                                spanCol: 12,
                                // isHideItem: !isNil(data.id) && isNil(data.financialSealFile),
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                extra: '规格：150像素（宽）*150像素（高），白底透明，支持JPG、JPEG、PNG格式',
                                children: (
                                    <SFormUploadImage
                                        accept={'.jpg,.jpeg,.png'}
                                        beforeUpload={beforeUpload}
                                        disabled={disabled || authVisible}
                                        maxCount={1}
                                        limit={1}
                                        url={baseURL + '/file-web/file/upload'}
                                    />
                                ),
                            },
                        ],
                    },
                ]}
            />
        </Spin>
    )
})
